import APIV5 from '~/models/api';
import Defaults from '~/scripts/constants/defaults';
import ModalUploadingController from '~/components/upload/modal/modal-uploading.controller';
import templateModalUploadClassic from '~/components/upload/modal/modal-uploading.html';
import { wfGetJobDescription } from '~/scripts/services/model/workflow';

/* globals Knitiv */

/**
 * @typedef WfFormActionsControllerOptions
 * @property {{path: any, search: any}} [from]
 * @property {boolean} [hideHistory]
 * @property {number} [maxFiles]
 * @property {boolean} [modal]
 * @property {('abort'|'reassign'|import('@knitiv/api-client-javascript').KNode)} [defaultAction]
 */

export default class WfFormActionsController {
	/* @ngInject */
	/**
	 * @param {import('angular').IFilterService} $filter
	 * @param {import('angular').auto.IInjectorService} $injector
	 * @param {import('angular').ILocationService} $location
	 * @param {import('angular').IQService} $q
	 * @param {Knitiv.RootScope} $rootScope
	 * @param {any} $scope
	 * @param {import('angular').ITimeoutService} $timeout
	 * @param {import('angular').translate.ITranslateService} $translate
	 * @param {import('angular').ui.bootstrap.IModalService} $uibModal
	 * @param {import('~/scripts/providers/models/notification').NotificationService} Notification
	 * @param {ReturnType<import('~/scripts/services/ui-action.service').UIActionService>} UIActionService
	 * @param {Knitiv.UserModel} User
	 */
	constructor(
		$filter,
		$injector,
		$location,
		$q,
		$rootScope,
		$scope,
		$timeout,
		$translate,
		$uibModal,
		Notification,
		UIActionService,
		User,
	) {
		this.$filter = $filter;
		this.$injector = $injector;
		this.$location = $location;
		this.$q = $q;
		this.$rootScope = $rootScope;
		this.$scope = $scope;
		this.$timeout = $timeout;
		this.$translate = $translate;
		this.$uibModal = $uibModal;
		this.Notification = Notification;
		this.UIActionService = UIActionService;
		this.User = User;

		/** @type {any[]} */
		this.actions = [];

		/** @type {?import('@knitiv/api-client-javascript').KNode} */
		this.actionKid = null;

		/** @type {boolean} */
		this.affectAuto = false;

		/** @type {?import('@knitiv/api-client-javascript').KNode} */
		this.affectKid = null;

		/** @type {any[]} */
		this.allocator = [];

		/** @type {any[]} */
		this.allocators = [];

		this.allocatorMfCustom = {
			selectable: [
				'K_NODE;WF_ROLE',
				'K_NODE;KPROFIL',
			],
		};

		/** @type {string} */
		this.comment = '';

		/** @type {any} */
		this.currentAction = undefined;

		/** @type {string} */
		this.currentInitKey = 'workflow.choose-action';

		/** @type {string} */
		this.currentKey = 'workflow.choose-action';

		/** @type {WfFormActionsControllerOptions} */
		this.defaultOptions = {
			from:        undefined,
			hideHistory: false,
			maxFiles:    Defaults.KCARDN,
			modal:       false,
		};

		/** @type {boolean} */
		this.disabled = false;

		/** @type {boolean} */
		this.displayAllocators = false;

		/** @type {boolean} */
		this.displayHistory = false;

		/** @type {boolean} */
		this.displayNotify = false;

		/** @type {boolean} */
		this.displayRecipient = false;

		/** @type {any} */
		this.fileParams = {
			camera: true,
			local:  true,
			tree:   true,
			html:   true,
			accept: ['*'],
		};

		/** @type {?import('angular').IFormController} */
		this.formWF = null;

		/** @type {any[]} */
		this.histo = [];

		/** @type {?import('@knitiv/api-client-javascript').KNode} */
		this.kid = null;

		/** @type {boolean} */
		this.loading = false;

		/** @type {import('~/components/mf/mf.controller').MfOptions} */
		this.mfAllocatorOptions = {
			displayValues: true,
			errors: {
				emptyResults: 'workflow.no-allocator',
			},
		};

		/** @type {any[]} */
		this.notify = [];

		/** @type {import('~/scripts/services/model/observation').default[]} */
		this.observations = [];

		/** @type {?Function} */
		this.onClick = null;

		/** @type {?Function} */
		this.onCancel = null;

		/** @type {?Function} */
		this.onRedirect = null;

		/** @type {WfFormActionsControllerOptions} */
		this.options = { ...this.defaultOptions };

		/** @type {any[]} */
		this.profillist = [];

		/** @type {any[]} */
		this.reafectationList = [];

		/** @type {boolean} */
		this.requiredComment = false;

		/** @type {boolean} */
		this.showAdminActions = false;

		/** @type {boolean} */
		this.showReassign = false;

		this.state_kjson = undefined;
		this.state = undefined;

		/** @type {boolean} */
		this.stateFinal = false;

		/** @type {any[]} */
		this.states = [];

		/** @type {string} */
		this.title = 'workflow.waiting-action';

		/** @type {any[]} */
		this.toProcess = [];

		/** @type {any} */
		this.wf = undefined;
	}

	abort() {
		this.currentAction = {
			kid:     'abort',
			name:    this.$translate.instant('workflow.action-abort'),
			nostate: true,
		};

		this.allocator.length = 0;
		this.allocators.length = 0;
		this.displayRecipient = false;
		this.profillist.length = 0;
		this.requiredComment = true;
	}

	cancel() {
		if (this.onCancel && typeof this.onCancel === 'function') {
			return this.onCancel({
				controller: this,
			});
		}
		return this.reset();
	}

	/**
	 * @param {any} job
	 * @returns {string}
	 */
	getJobDescription(job) {
		return wfGetJobDescription(this.$injector, job);
	}

	/**
	 * @param {import('@knitiv/api-client-javascript').KNode} stateKid
	 * @returns {Promise<any>} State info
	 */
	async getStateInfo(stateKid) {
		const wfactionKid = this.currentAction.kid === 'reassign'
			? 'K_NODE;WFAC_REASSIGN'
			: this.currentAction.kid;
		if (this.affectKid && stateKid && wfactionKid) {
			return APIV5.instance.wfAffectGetStateInfo(
				{
					wfaffect_kid: this.affectKid,
					wfstate_kid:  stateKid,
					wfaction_kid: wfactionKid,
				},
				{
					id: 'wf-form-actions.get-state-info',
				},
			);
		}
		return false;
	}

	async initWorkflow() {
		if (this.affectKid) {
			if (!this.options.hideHistory) {
				const affectHisto = await APIV5.instance.wfAffectHisto({
					wfaffect_kid: this.affectKid,
				}, {
					id: 'wf-form-actions.init-workflow',
				});
				this.displayHistory = true;
				this.$timeout(() => {
					this.histo = affectHisto.histo;
				});
			}

			if (!this.disabled && this.wf && this.wf?.status.kid !== 'K_NODE;WFS_ABORT') {
				const affectGetAction = await APIV5.instance.wfAffectGetAction({
					wfaffect_kid: this.affectKid,
				}, {
					id: 'wf-form-actions.init-workflow',
				});
				this.$timeout(() => {
					this.actions = affectGetAction?.actionlist || [];
				});
			}
		}
	}

	async reassign() {
		this.allocator.length = 0;
		this.requiredComment = false;

		this.currentAction = {
			kid:     'reassign',
			name:    this.$translate.instant('workflow.action-reassign'),
			nostate: true,
		};

		const info = await this.getStateInfo(this.wf.state.kid);
		this.allocators = info.wfallocatorlist;

		if (this.allocators.length === 1) {
			this.allocator.push({
				kid: this.allocators[0].kid,
				name: this.allocators[0].name,
			});
		}
		else {
			// Affectataire par défaut
			const currentProfil = this.User?.getProfil();
			if (
				currentProfil?.kid
				&& this.allocators.some(allocator => allocator.kid === currentProfil.kid || allocator.kid === 'K_NODE;KR_TOUS')
			) {
				this.allocator.push({
					kid: currentProfil.kid,
					name: currentProfil.name,
				});
			}
		}

		this.displayAllocators = true;
		this.$timeout(() => {
			this.formWF?.$setPristine();
			this.formWF?.$setUntouched();
		});
	}

	/**
	 * @returns {Promise<import('angular').ILocationService|void>} redirection promise
	 */
	async redirect() {
		if (typeof this.onRedirect === 'function') {
			return this.onRedirect();
		}

		const data = await APIV5.instance.wfAffectTodo({}, { id: 'wf-form-actions.redirect' });
		let col;
		for (const [k, header] of Object.entries(data.header)) {
			if (header.id === 'kid') {
				col = k;
			}
		}

		if (col && data.rows.length > 0) {
			const nextAffectKid = data.rows[0][col].kid;
			this.Notification.info({
				title:   this.$translate.instant('common.info'),
				message: this.$translate.instant('workflow.next'),
			});

			if (nextAffectKid === this.affectKid) {
				this.reset();
				return this.initWorkflow();
			}

			return this.$location.url(`/workflow/${nextAffectKid}`);
		}

		this.Notification.info({
			title:   this.$translate.instant('common.info'),
			message: this.$translate.instant('workflow.no-more'),
		});
		return this.$timeout(() => this.$location.url('/'));
	}

	reset() {
		this.allocator.length = 0;
		this.allocators.length = 0;
		this.comment = '';
		this.currentAction = undefined;
		this.displayAllocators = false;
		this.displayRecipient = true;
		this.loading = false;
		this.notify.length = 0;
		this.profil_kid = null;
		this.profillist.length = 0;
		this.requiredComment = false;
		this.state = undefined;
		this.stateFinal = false;
		this.affectAuto = false;
		this.states.length = 0;
	}

	/**
	 * @param {any} action
	 * @returns {Promise<any>} returns promise
	 */
	async selectAction(action) {
		try {
			action.kjson = JSON.parse(action.kjson);
		}
		catch { /* empty */ }
		this.currentAction = action;
		this.requiredComment = false;

		if (action.kid && this.affectKid) {
			const data = await APIV5.instance.wfAffectGetStateFromAction(
				{
					wfaction_kid: action.kid,
					wfaffect_kid: this.affectKid,
				},
				{
					id: 'wf-form-actions.select-action',
				},
			);
			this.states = data.statelist;
		}
		else {
			this.states.length = 0;
		}

		this.$timeout(() => {
			if (this.states.length === 1) {
				this.state = this.states[0].kid;
				this.selectState(this.states[0]);
			}
			else {
				this.state = undefined;
			}
		});
	}

	/**
	 * @param {any} item
	 */
	async selectState(item) {
		const info = await this.getStateInfo(item.kid);
		this.displayAllocators = true;
		this.affectAuto = info.wfstate.affectAuto;
		this.allocator.length = 0;
		this.allocators = info.wfallocatorlist;
		this.stateFinal = info.wfstate.final;
		this.wf.state.observCard = info.wfstate.observCard;

		if (this.allocators.length === 1 && this.allocators[0].kid !== 'K_NODE;KR_WF_TOUS') {
			this.allocator.push({
				kid: this.allocators[0].kid,
				name: this.allocators[0].name,
			});
		}

		this.$timeout(() => {
			if (this.affectAuto || this.stateFinal) {
				this.formWF?.$setDirty();

				if (this.stateFinal) {
					this.allocator.push({ kid: this.User?.getProfil().kid });
				}
			}
		});
	}

	/**
	 * @deprecated
	 * @returns {boolean} result
	 */
	setDisabled() {
		let okInit = true;
		if ((this.profillist.length === 0) && (this.currentKey === this.currentInitKey)) {
			okInit = false;
		}

		let okComment = true;
		if (this.requiredComment && this.comment.trim() === '') {
			okComment = false;
		}
		let okProfilKid = true;
		if (this.profillist.length > 0 && !this.profil_kid) {
			okProfilKid = false;
		}

		this.disabled = !(okComment && okProfilKid && okInit);

		return this.disabled;
	}

	async submit() {
		this.loading = true;
		try {
			if (this.observations.length > 0) {
				const modalInstance = this.$uibModal.open({
					ariaLabelledBy:  'modal-uploading-title',
					ariaDescribedBy: 'modal-uploading-body',
					backdrop:        false,
					controller:      ModalUploadingController,
					controllerAs:    '$ctrl',
					template:        templateModalUploadClassic,
					size:            'sm',
					resolve:         {
						files: () => this.observations,
					},
					windowClass:     'modal-upload',
				});
				const opened = await modalInstance.opened;

				if (opened) {
					const result = await this.observations.reduce(
						(p, file) => p
							.then(() => file.upload()),
						this.$q.when(true),
					);

					if (result) {
						this.Notification.success({
							title:   this.$translate.instant('import.imported-files-title'),
							message: this.$translate.instant('import.imported-files-message'),
						});

						this.$timeout(() => {
							modalInstance.close();
						}, 1000);
					}
				}
			}

			if (this.onClick && typeof this.onClick === 'function') {
				await this.onClick({
					controller: this,
				});
				this.loading = false;
			}
			else {
				switch (this.currentAction.kid) {
				case 'abort': {
					if (this.affectKid) {
						const abort = await APIV5.instance.wfAffectAbort(
							{
								wfaffect_kid: this.affectKid,
								wfcomment:    this.comment,
							},
							{ id: 'wf-form-actions.submit.abort' },
						);
						if (abort) {
							this.reset();
							await this.redirect();
							this.Notification.success({
								title:   this.$translate.instant('object.successfully-action-title'),
								message: this.$translate.instant('workflow.abort-success'),
							});
						}
					}
					break;
				}

				case 'reassign': {
					if (this.affectKid) {
						const assign = await APIV5.instance.wfAffectReassign(
							{
								wfaffect_kid: this.affectKid,
								wfallocator:  this.allocator?.map(allocator => allocator.kid),
								wfcomment:    this.comment,
							},
							{
								id: 'wf-form-actions.submit.reassign',
							},
						);
						if (assign) {
							this.reset();
							await this.redirect();
							this.Notification.success({
								title:   this.$translate.instant('object.successfully-action-title'),
								message: this.$translate.instant('workflow.reassign-success'),
							});
						}
					}
					break;
				}

				default: {
					if (this.affectKid) {
						const setAction = await APIV5.instance.wfAffectSetAction(
							{
								wfaffect_kid: this.affectKid,
								wfaction_kid: this.currentAction.kid,
								wfstate_kid:  this.state,
								wfallocator:  this.affectAuto || this.allocator.length === 0
									? undefined : this.allocator.map(allocator => allocator.kid),
								wfnotify:     this.notify.map(notify => notify.kid),
								wfcomment:    this.comment,
								// @ts-ignore
								wfobservations: this.observations.map(o => ({
									fileid:  o.id,
									name:    o.name,
									comment: o.comment,
								})),
							},
							{ id: 'wf-form-actions.submit.default' },
						);
						if (setAction) {
							this.reset();
							// @ts-ignore
							if (!('UI' in setAction && setAction.UI.actions?.length > 0)) {
								await this.redirect();
							}
							this.Notification.success({
								title:   this.$translate.instant('object.successfully-action-title'),
								message: this.$translate.instant('workflow.action-success'),
							});
						}
					}
				}
				}
			}
		}
		catch (/** @type {any} */ error) {
			let message = this.$translate.instant('error.file-not-imported-error');

			if ('status' in error && error.status === -1) {
				message = this.$translate.instant('error.network-disconnected');
			}
			console.error(error);
			this.loading = false;

			this.Notification.warning({
				title:    this.$translate.instant('error.file-not-imported-title'),
				template: message,
			});
		}
	}

	$doCheck() {
		if (this.wf?.state && this.wf.state.observCard.to > 0 && this.formWF) {
			this.formWF.$valid = this.observations.length >= this.wf.state.observCard.from;
		}
	}

	/**
	 * @param {import('angular').IOnChangesObject} changes
	 */
	$onChanges(changes) {
		if (this.options === undefined) {
			this.options = { ...this.defaultOptions };
		}

		if (changes.affectKid && this.affectKid) {
			(async () => this.initWorkflow())();
		}
	}

	$onInit() {
		this.displayRecipient = true;
		this.notify = [];
		this.options = {
			...this.defaultOptions,
			...this.options,
		};

		if (this.options.defaultAction) {
			(async () => {
				switch (this.options.defaultAction) {
				case 'abort': {
					this.title = 'workflow.action-abort';
					this.abort();
					break;
				}
				case 'reassign': {
					this.title = 'workflow.action-reassign';
					await this.reassign();
					break;
				}
				default: {
					await this.selectAction(this.options.defaultAction);
				}
				}
			})();
		}

		this.showAdminActions = this.$rootScope.context?.role.mode === 'ADMIN_SUPER'
			|| this.$rootScope.context?.role.sql_in.includes('K_NODE;KR_ADMIN_WF') || false;

		this.showReassign = this.showAdminActions || this.wf.allocatorTo.some(
			(/** @type {any} */ allocator) => allocator.kid === this.$rootScope.context?.profil.kid,
		);

		this.$scope.$on('change-recipient', (/** @type {any} */ event, /** @type {any} */ model) => {
			this.profil_kid = model;
		});

		this.$scope.$on('change-recipients', (/** @type {any} */ event, /** @type {any[]} */ model) => {
			this.notify = model;
		});
	}
}
